import React from "react";
import { Box, Link as MuiLink, List, ListItem, Typography } from "@mui/material";
import { PageShell, SectionCard } from "../components/ui";
import "./css/WelcomePage.css";

const WelcomePage = () => {
  return (
    <PageShell maxWidth="lg" className="welcome-page-shell">
      <SectionCard className="welcome-container" sx={{ p: { xs: 2, md: 3 } }}>
        <Typography variant="h4" component="h1" sx={{ mb: 2, textAlign: "center" }}>
          Welcome to AoZ Companion
        </Typography>

        <Typography paragraph>
          AOZ Companion is a tool developed by Clay from nation 1115 to help with
          many things in Age of Origins. Add alliance and commander data to track
          players over time, map out your nation to plan your territory, elite
          mines, benefit buildings, or plan your hive.
        </Typography>
        <Typography paragraph>
          Alliance Management lets you create votes to determine event times and
          support nation-level decisions.
        </Typography>
        <Typography paragraph>
          Certain features are restricted based on users and roles. If you would
          like to register as a user or admin, see below.
        </Typography>

        <Typography variant="h6" component="h2" className="section-header">
          How to Register
        </Typography>
        <List dense className="text-list">
          <ListItem>During registration, attach a screenshot of your commander profile.</ListItem>
          <ListItem>An existing Nation Admin can approve you and update your role.</ListItem>
          <ListItem>
            If you are the first user from your nation, Clay will update you to Nation Admin.
          </ListItem>
          <ListItem>
            This helps ensure only players from your nation have access to your map.
          </ListItem>
          <ListItem>Contact Clay on Discord if you need help with approval delays.</ListItem>
        </List>

        <Typography variant="h6" component="h2" className="section-header">
          Contact and Support
        </Typography>
        <List dense className="text-list">
          <ListItem>If you would like to support this project, blue coins are welcome.</ListItem>
          <ListItem>
            Commander ID: 109701705 —
            <MuiLink
              href="https://pay-service.ageoforiginsgame.com/#/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ ml: 0.5 }}
            >
              AoZ Coins Page
            </MuiLink>
          </ListItem>
          <ListItem>Discord: 1115_clay</ListItem>
          <ListItem>
            Clay is happy to help collect data and map out nations for supporters.
          </ListItem>
        </List>

        <Typography variant="h5" component="h2" sx={{ mt: 1, mb: 1.5, textAlign: "center" }}>
          Demo Videos
        </Typography>
        <Box className="videos-wrapper">
          <Box className="video-container">
            <iframe
              src="https://www.youtube.com/embed/fdpRv7ZwEbY?si=HXKJlltnohK-NUsV"
              title="AoZ Companion Demo - Overview"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Box>
          <Box className="video-container">
            <iframe
              src="https://www.youtube.com/embed/A4KEODy03yU?si=Nn4qT85OOYjFEzha"
              title="AoZ Companion Demo - Advanced Usage"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </Box>
        </Box>

        <Typography variant="h6" component="h2" className="section-header">
          Current Permission Model
        </Typography>
        <List dense className="text-list">
          <ListItem>
            Anyone can publicly view information on nations, alliances, and commanders.
          </ListItem>
          <ListItem>
            Registered users who verify their nation can view their nation map.
          </ListItem>
          <ListItem>
            Nation Admins can add/edit data including alliances, commanders, and map plans.
          </ListItem>
        </List>
      </SectionCard>
    </PageShell>
  );
};

export default WelcomePage;
